// extracted by mini-css-extract-plugin
module.exports = {"createBlock":"styles_createBlock__2G-Va","createBlock__centralBlock":"styles_createBlock__centralBlock__3uYuJ"};